import Facebook from "@/pixels/ofertaCajaAhorro/google";
import { ERROR_SOLICITUD, RECHAZADO } from "@/config/constants/step-constants";

describe("Google enable function", () => {
  let script;
  beforeEach(() => {
    script = {
      setAttribute: jest.fn(),
      onload: null
    };
    document.createElement = jest.fn(() => script);
    document.getElementsByTagName = jest.fn(() => [{ appendChild: jest.fn() }]);
    window.gtag = jest.fn();
    window.fbq = jest.fn();
  });

  it("Evento enable", () => {
    Facebook.enable();
    script.onload();
    expect(window.dataLayer).toBeDefined();
    expect(window.gtag).toBeDefined();
  });

  it("Evento enable    ", () => {
    window.dataLayer = [];
    Facebook.enable();
    script.onload();
    expect(window.dataLayer).toBeDefined();
    expect(window.gtag).toBeDefined();
  });

  it("Evento wait", () => {
    Facebook.wait();
    expect(window.gtag).toBeDefined();
  });

  it("Evento init", () => {
    Facebook.init();
    expect(window.fbq).toHaveBeenCalledWith("init", "1649877658563488");
  });

  it("Evento consulta", () => {
    Facebook.consulta();
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      send_to: "AW-793298531/i5RYCM7ljqAYEOOMo_oC",
      transaction_id: ""
    });
  });

  it("Evento ofertaCuenta", () => {
    Facebook.ofertaCuenta();
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      send_to: "AW-793298531/2PaxCOaMj6AYEOOMo_oC",
      transaction_id: ""
    });
  });

  it("Evento mensaje x RECHAZADO", () => {
    Facebook.mensaje({
      mutation: { payload: { params: { mje: RECHAZADO } } }
    });
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      send_to: "AW-793298531/VGmjCIb4maAYEOOMo_oC",
      transaction_id: ""
    });
  });

  it("Evento mensaje x ERROR_SOLICITUD", () => {
    Facebook.mensaje({
      mutation: { payload: { params: { mje: ERROR_SOLICITUD } } }
    });
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      send_to: "AW-793298531/VGmjCIb4maAYEOOMo_oC",
      transaction_id: ""
    });
  });

  it("Evento mensaje x default", () => {
    Facebook.mensaje({
      mutation: { payload: { params: { mje: "" } } }
    });
    expect(window.gtag).not.toHaveBeenCalled();
  });
});
